import { useQuery } from '@tanstack/react-query';

import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { gqlClient } from '../../graphql-client';

const GetMe = graphql(`
  query GetMe {
    me {
      permissions
      emailSignature
      hasChatAgentAccess
      preferences {
        useNewDashboard
      }
      user {
        id
        publicId
        firstName
        fullName
        isPrimaryUser
        systemRole
        phone
        account {
          id
          name
          phone
          email
          enforceSSO
          externalPaymentRedirectUrl
          analytics {
            embeddableDashboards {
              title
              uniqueIdentifier
              embedUrl
            }
          }
        }
        originalAccountId
        costPerHour {
          value
          currency {
            id
            code
            exponent
          }
        }
      }
      integrations {
        google {
          isActive
          email
        }
      }
    }
  }
`);

const useGetMe = () => {
  const { data, ...rest } = useQuery({
    queryKey: meKeys.all,
    queryFn: async () => gqlClient.request(GetMe),
  });
  return {
    data: data?.me,
    user: data?.me?.user,
    analytics: data?.me?.user?.account?.analytics,
    hasChatAgentAccess: data?.me?.hasChatAgentAccess ?? false,
    preferences: data?.me?.preferences,
    ...rest,
  };
};

export default useGetMe;
